import {Component, OnDestroy, OnInit} from '@angular/core';
import {FileShareService} from '../../_services/api/file-share.service';
import {ActivatedRoute} from '@angular/router';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {saveAs} from 'file-saver';
import {FileService} from '../../_services/api/file.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {loginItem, loginItemList} from '../../_animations/loginAnimations';
import {WebSocketSubject} from 'rxjs/webSocket';
import {concat} from 'rxjs';

@Component({
  selector: 'app-download-share-file-view',
  templateUrl: './download-share-file-view.component.html',
  styleUrls: ['./download-share-file-view.component.scss', '../../../loginForm.scss'],
  animations: [loginItemList, loginItem]
})
export class DownloadShareFileViewComponent implements OnInit, OnDestroy {

  loading: boolean;
  isPassword: boolean;
  status: string;
  processingProgress: any;
  preperingProgress: number;
  downloadProgress: number;
  downloadLabel: string;
  queueId: string;
  token: string;
  passwordForm: FormGroup;
  message: string;
  messageType: string;
  downloadWebSocket: WebSocketSubject<any>;

  constructor(private fileShareService: FileShareService, private activatedRoute: ActivatedRoute, private fileService: FileService, private formBuilder: FormBuilder) {
    this.loading = true;
    this.downloadProgress = 0;
    this.preperingProgress = 0;
    this.downloadLabel = '';
    this.processingProgress = {};
    this.queueId = Math.random().toString(36).slice(2, 7);
  }

  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group(
      {
        file_password: ['', [
          Validators.required
        ]],
      }
    );

    this.activatedRoute.params.subscribe(params => {
      this.token = params.token;
      // const url = ANONYMIZATION_STATUS_WEBSOCKET + this.token;
      //
      // this.downloadWebSocket = webSocket(url);
      // this.downloadWebSocket.pipe(retry()).subscribe( res => {
      //   if (res.type === 'preparing_download') {
      //     if (this.processingProgress[res.token] !== undefined){
      //       this.processingProgress[res.token].processing = res.progress / 100;
      //       this.processingProgress = {...this.processingProgress};
      //     }
      //   }
      // });

      this.fileShareService.check(this.token).subscribe( res => {
        this.loading = false;
        if (!res.expired) {
          if (res.has_password) {
            this.status = 'password';
          } else {
            this.startDownload('');
          }
          this.isPassword = res.has_password;
        } else {
          this.status = 'expired';
        }
      },
        error => {
          this.status = 'bad_token';
          this.loading = false;
        });
    });
  }


  startDownload(password) {
    this.status = 'downloading';
    this.downloadProgress = 0;
    this.fileShareService.downloadInfo(this.token, password, this.queueId).subscribe((res) => {
      const requests = [];
      const queueIds = [];
      let i = 0;

      res.forEach( r => {
          const tempQueueId = Math.random().toString(36).slice(2, 7);
          this.processingProgress[tempQueueId] = {processing: 0, uploading: 0, type: 'downloading'};
          requests.push(this.fileShareService.download(this.token, password, r, tempQueueId));
          queueIds.push(tempQueueId);
        });
      if (requests.length > 1){
        this.downloadLabel = 'Downloading 1 of ' + requests.length + ' files.' ;
      } else {
        this.downloadLabel = 'Downloading...' ;
      }

      concat(...requests).subscribe((event: HttpEvent<any>) => {
        switch (event.type) {
            case HttpEventType.DownloadProgress:
              this.processingProgress[queueIds[i]].uploading = (event.loaded / event.total);
              this.processingProgress[queueIds[i]].processing = 1;
              this.processingProgress = {...this.processingProgress};
              if (requests.length > 1){
                this.downloadLabel = 'Downloading ' + (i + 1).toString() + ' of ' + requests.length + ' files.' ;
              } else {
                if (event.loaded / event.total >= 0.9) {
                  this.downloadLabel = 'Almost finished!';
                } else {
                  this.downloadLabel = 'Downloading...';
                }
              }

              break;
            case HttpEventType.Response:
              const response = event.body;
              console.log(response.type);
              const ext = this.fileService.getFileExtensionForDownload(response.type);
              const blob = new Blob([response], {
                type: response.type
              });
              let filename = this.fileService.getFileName(ext);

              if (requests.length > 1) {
                filename = this.fileService.getFileName(ext, i + 1, requests.length);
              }
              saveAs(blob, filename);
              i += 1;
              if (i === requests.length){
                this.status = 'done';
              } else {
                if (requests.length > 1){
                  this.downloadLabel = 'Downloading ' + (i).toString() + ' of ' + requests.length + ' files.' ;
                }
              }
          }
      }, error => {
          console.log(error);
          this.status = 'error';
        }
        );
      }, error => {
        if (this.isPassword) {
          this.status = 'password';
          this.message = 'Wrong password';
          this.messageType = 'danger';
        } else {
          this.status = 'error';
        }
      });
  }

  submitPassword() {
    this.startDownload(this.passwordForm.value.file_password);
  }

  ngOnDestroy() {
    if (this.downloadWebSocket !== undefined){
      this.downloadWebSocket.unsubscribe();
    }
  }

  reload(){
    window.location.reload();
  }

}
